<div class="location-route-data" *ngIf="!skeletonLoading">

    <div class="data-container">
        <div class="data-row" *ngIf="title != null && title != ''">
            <div class="">
                <label class="title bold"> Nombre:</label>
            </div>
            <div class="">
                <label class="body"> {{ title | slice:0:30 }}</label>
            </div>
        </div>

        <div class="data-row" *ngIf="title != null && title != ''">
            <div class="">
                <label class="title bold"> Id:</label>
            </div>
            <div class="">
                <label class="body"> {{ key | slice:0:30 }}</label>
            </div>
        </div>

        <div class="data-row orange" *ngIf="status != null && status != ''">
            <div class="">
                <label class="title light-bold"> Estatus:</label>
            </div>
            <div class="">
                <label class="body bold"> {{ status | slice:0:30 }}</label>
            </div>
        </div>
    </div>

    <div class="data-container" *ngIf="subtitle != null && subtitle != ''">
        <div class="data-row-vertical">
            <div class="">
                <label class="title bold"> Descripción:</label>
            </div>
            <div class="">
                <label class="body light-bold"> {{ subtitle }}</label>
            </div>
        </div>
    </div>

    <div class="data-container">
        <div class="data-row-vertical" *ngFor="let field of fields">
            <div class="">
                <label class="title bold"> {{ field.label }}:</label>
            </div>
            <div class="">
                <label class="body light-bold"> {{ field.value }}</label>
            </div>
        </div>
    </div>

</div>

<div class="location-route-data" *ngIf="skeletonLoading">
    <div class="data-container">
        <div class="data-row">
            <div class="">
                <label class="title bold">
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '40px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
            <div class="">
                <label class="body">
                  <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '150px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
        </div>
    </div>

    <div class="data-container">
        <div class="data-row-vertical" *ngFor="let skel of [1,2,3]">
            <div class="">
                <label class="title bold">
                    <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '40px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
            <div class="">
                <label class="body light-bold">
                  <ngx-skeleton-loader count="1" appearance="line" [theme]="{ 'border-radius': '8px', 'height': '5px', 'width': '150px', 'background-color': '#bdbdbd' }"></ngx-skeleton-loader>
                </label>
            </div>
        </div>
    </div>
</div>
